const theme = {
  primaryColor: "#74b9ff",
};

export default theme;
